
const mapActions = {
    setRequiresRefitAndMapUnstable: () => ({
        type: 'SET_REQUIRES_REFIT_AND_MAP_UNSTABLE'
    }),
    unsetMapUnstable: () => ({
        type: 'UNSET_MAP_UNSTABLE'
    }),
    unsetRequiresRefit: () => ({
        type: 'UNSET_REQUIRES_REFIT'
    }),
    toggleAwaitingResults: awaitingResults => ({
        type: 'TOGGLE_AWAITING_RESULTS',
        payload: {
            awaitingResults
        }
    }),
    toggleSearchOnMapMove: () => ({
        type: 'TOGGLE_SEARCH_ON_MAP_MOVE'
    })
};

export default mapActions;



// WEBPACK FOOTER //
// ./src/pages/Search/actions/mapActions.js